import dayjs from 'dayjs';
/**
 * @description 读取剪切板
 */
export var clipBoardRead = {
    read: function (e, callback) {
        // @ts-ignore
        var clip = window.clipboardData || e.clipboardData;
        if (!clip || !clip.items) {
            return;
        }
        var i = 0;
        var len = clip.items.length;
        var item;
        var image = null;
        var html = null;
        var text = null;
        for (; i < len; i++) {
            item = clip.items[i];
            if (item.kind === 'file' && item.type.indexOf('image') !== -1) {
                image = item.getAsFile();
                var reader = new FileReader();
                reader.onload = function (ev) {
                    var name = "".concat(dayjs().format('YYYY-MM-DD HH:mm:ss'), ".png");
                    callback('image', "<img data-name=\"".concat(name, "\" src=\"").concat(ev.target.result, "\" data-src=\"src\" data-type=\"image\" />"));
                };
                reader.readAsDataURL(image);
            }
            else if (item.type === 'text/html') {
                html = item;
            }
            else {
                text = item;
            }
        }
        if (html) {
            html.getAsString(function (str) {
                if (image) {
                    callback(null, str);
                }
                else {
                    callback('string', str);
                }
            });
        }
        else if (text) {
            text.getAsString(function (str) {
                callback('string', str);
            });
        }
        else {
            callback('string', clip.getData('Text'));
        }
    },
    readText: function (e, callback) {
        if (!e.clipboardData || !e.clipboardData.items) {
            return false;
        }
        var i = 0;
        var len = e.clipboardData.items.length;
        var item;
        for (; i < len; i++) {
            item = e.clipboardData.items[i];
            if (item.type === 'text/plain') {
                item.getAsString(function (str) {
                    callback(str);
                });
                return true;
            }
        }
        callback(null);
        e.preventDefault();
    }
};
/** 复制文本内容 */
export var copy = function (str, success) {
    var input = document.createElement('textarea');
    document.body.appendChild(input);
    input.innerHTML = str;
    input.select();
    document.execCommand('copy');
    success === null || success === void 0 ? void 0 : success();
    document.body.removeChild(input);
};
